import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/${number | ':workOrderId'}/confirmation`;

export const ROUTE: RouteDefinition = `${baseRoute}/:workOrderId/confirmation`;

export const URL = (workOrderId: number): RouteDefinition => `${baseRoute}/${workOrderId}/confirmation`;
